/**
 * Generated by orval v6.10.3 🍺
 * Do not edit manually.
 * CMS-POC WebAPI
 * OpenAPI spec version: 1.0
 */
import axios from 'axios'
import type {
  AxiosRequestConfig,
  AxiosResponse,
  AxiosError
} from 'axios'
import {
  useQuery,
  useMutation
} from '@tanstack/react-query'
import type {
  UseQueryOptions,
  UseMutationOptions,
  QueryFunction,
  MutationFunction,
  UseQueryResult,
  QueryKey
} from '@tanstack/react-query'
import type {
  PrivilegesList,
  ErrorInfo,
  BinaryFile,
  GetPrivilegesId200,
  PostPrivilegesUpdate200,
  PostPrivilegesUpdateBody
} from '.././model'


/**
 * 権限管理の一覧を取得する。

 * @summary 権限一覧表示
 */
export const getPrivileges = (
     options?: AxiosRequestConfig
 ): Promise<AxiosResponse<PrivilegesList>> => {
    return axios.get(
      `/privileges`,options
    );
  }


export const getGetPrivilegesQueryKey = () => [`/privileges`];

    
export type GetPrivilegesQueryResult = NonNullable<Awaited<ReturnType<typeof getPrivileges>>>
export type GetPrivilegesQueryError = AxiosError<ErrorInfo>

export const useGetPrivileges = <TData = Awaited<ReturnType<typeof getPrivileges>>, TError = AxiosError<ErrorInfo>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getPrivileges>>, TError, TData>, axios?: AxiosRequestConfig}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetPrivilegesQueryKey();

  

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getPrivileges>>> = ({ signal }) => getPrivileges({ signal, ...axiosOptions });

  const query = useQuery<Awaited<ReturnType<typeof getPrivileges>>, TError, TData>(queryKey, queryFn, queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryKey;

  return query;
}

/**
 * 権限情報ダウンロード

 * @summary 権限情報ダウンロード
 */
export const getPrivilegesDownload = (
     options?: AxiosRequestConfig
 ): Promise<AxiosResponse<BinaryFile>> => {
    return axios.get(
      `/privileges/download`,options
    );
  }


export const getGetPrivilegesDownloadQueryKey = () => [`/privileges/download`];

    
export type GetPrivilegesDownloadQueryResult = NonNullable<Awaited<ReturnType<typeof getPrivilegesDownload>>>
export type GetPrivilegesDownloadQueryError = AxiosError<ErrorInfo>

export const useGetPrivilegesDownload = <TData = Awaited<ReturnType<typeof getPrivilegesDownload>>, TError = AxiosError<ErrorInfo>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getPrivilegesDownload>>, TError, TData>, axios?: AxiosRequestConfig}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetPrivilegesDownloadQueryKey();

  

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getPrivilegesDownload>>> = ({ signal }) => getPrivilegesDownload({ signal, ...axiosOptions });

  const query = useQuery<Awaited<ReturnType<typeof getPrivilegesDownload>>, TError, TData>(queryKey, queryFn, queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryKey;

  return query;
}

/**
 * 権限情報表示

 * @summary 権限情報表示
 */
export const getPrivilegesId = (
    privilegeId: number, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<GetPrivilegesId200>> => {
    return axios.get(
      `/privileges/${privilegeId}`,options
    );
  }


export const getGetPrivilegesIdQueryKey = (privilegeId: number,) => [`/privileges/${privilegeId}`];

    
export type GetPrivilegesIdQueryResult = NonNullable<Awaited<ReturnType<typeof getPrivilegesId>>>
export type GetPrivilegesIdQueryError = AxiosError<ErrorInfo>

export const useGetPrivilegesId = <TData = Awaited<ReturnType<typeof getPrivilegesId>>, TError = AxiosError<ErrorInfo>>(
 privilegeId: number, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getPrivilegesId>>, TError, TData>, axios?: AxiosRequestConfig}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetPrivilegesIdQueryKey(privilegeId);

  

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getPrivilegesId>>> = ({ signal }) => getPrivilegesId(privilegeId, { signal, ...axiosOptions });

  const query = useQuery<Awaited<ReturnType<typeof getPrivilegesId>>, TError, TData>(queryKey, queryFn, {enabled: !!(privilegeId), ...queryOptions}) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryKey;

  return query;
}

/**
 * 権限情報更新

 * @summary 権限情報更新
 */
export const postPrivilegesUpdate = (
    privilegeId: number,
    postPrivilegesUpdateBody: PostPrivilegesUpdateBody, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<PostPrivilegesUpdate200>> => {
    return axios.post(
      `/privileges/${privilegeId}/update`,
      postPrivilegesUpdateBody,options
    );
  }



    export type PostPrivilegesUpdateMutationResult = NonNullable<Awaited<ReturnType<typeof postPrivilegesUpdate>>>
    export type PostPrivilegesUpdateMutationBody = PostPrivilegesUpdateBody
    export type PostPrivilegesUpdateMutationError = AxiosError<ErrorInfo>

    export const usePostPrivilegesUpdate = <TError = AxiosError<ErrorInfo>,
    
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postPrivilegesUpdate>>, TError,{privilegeId: number;data: PostPrivilegesUpdateBody}, TContext>, axios?: AxiosRequestConfig}
) => {
      const {mutation: mutationOptions, axios: axiosOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postPrivilegesUpdate>>, {privilegeId: number;data: PostPrivilegesUpdateBody}> = (props) => {
          const {privilegeId,data} = props ?? {};

          return  postPrivilegesUpdate(privilegeId,data,axiosOptions)
        }

      return useMutation<Awaited<ReturnType<typeof postPrivilegesUpdate>>, TError, {privilegeId: number;data: PostPrivilegesUpdateBody}, TContext>(mutationFn, mutationOptions)
    }
    